import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { createContext, memo, useContext, useMemo, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
export const initialScrollElementContext = {
    scrollElement: null,
    setScrollElement: noop
};
export const ScrollElementContext = /*#__PURE__*/ createContext(initialScrollElementContext);
export const ScrollElementContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [scrollElement, setScrollElement] = useState(null);
    const value = useMemo(()=>({
            scrollElement,
            setScrollElement
        }), [
        scrollElement
    ]);
    return /*#__PURE__*/ _jsx(ScrollElementContext.Provider, {
        value: value,
        children: children
    });
});
ScrollElementContextProvider.displayName = "ScrollElementContextProvider";
export const ScrollElementContextConsumer = ScrollElementContext.Consumer;
export const useScrollElementContext = ()=>{
    const context = useContext(ScrollElementContext);
    if (context === initialScrollElementContext) {
        const error = "useScrollElementContext must be used within a ScrollElementContextProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
